export default {
  init() {
    $("input#choice_8_5_0").on('click', function () {
		$('li.gchoice_8_5_0').css({"color":"#fff","background-color":"#709eb2"});
		$('li.gchoice_8_5_1').css({"color":"#709eb2","background-color":"#fff"});
	});
	$("input#choice_8_5_1").on('click', function () {
		$('li.gchoice_8_5_1').css({"color":"#fff","background-color":"#709eb2"});
		$('li.gchoice_8_5_0').css({"color":"#709eb2","background-color":"#fff"});
	});
	if($('input#choice_8_5_0').is(':checked')){ 
		$('li.gchoice_8_5_0').css({"color":"#fff","background-color":"#709eb2"});
	}
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js